// GetSections returns the navigation sections
export const NavigationPageService_GetSectionsLazy = () =>
  import("./service.grpc").then((m) => m.NavigationPageService_GetSections);
NavigationPageService_GetSectionsLazy.method =
  "aysa_api.services.navigation_page.v1.NavigationPageService/GetSections" as const;

// GetSectionsNext returns the next [limit] navigation sections based on [ContinuationToken]
export const NavigationPageService_GetSectionsNextLazy = () =>
  import("./service.grpc").then((m) => m.NavigationPageService_GetSectionsNext);
NavigationPageService_GetSectionsNextLazy.method =
  "aysa_api.services.navigation_page.v1.NavigationPageService/GetSectionsNext" as const;

// GetBrowsePage returns the browse page static parts
export const NavigationPageService_GetBrowsePageLazy = () =>
  import("./service.grpc").then((m) => m.NavigationPageService_GetBrowsePage);
NavigationPageService_GetBrowsePageLazy.method =
  "aysa_api.services.navigation_page.v1.NavigationPageService/GetBrowsePage" as const;

// GetBrowseSections returns the browse sections
export const NavigationPageService_GetBrowseSectionsLazy = () =>
  import("./service.grpc").then(
    (m) => m.NavigationPageService_GetBrowseSections
  );
NavigationPageService_GetBrowseSectionsLazy.method =
  "aysa_api.services.navigation_page.v1.NavigationPageService/GetBrowseSections" as const;

// GetBrowseSectionsNext returns the next [limit] browse sections based on [ContinuationToken]
export const NavigationPageService_GetBrowseSectionsNextLazy = () =>
  import("./service.grpc").then(
    (m) => m.NavigationPageService_GetBrowseSectionsNext
  );
NavigationPageService_GetBrowseSectionsNextLazy.method =
  "aysa_api.services.navigation_page.v1.NavigationPageService/GetBrowseSectionsNext" as const;

// GetSections returns the shop sections
export const NavigationPageService_GetShopSectionsLazy = () =>
  import("./service.grpc").then((m) => m.NavigationPageService_GetShopSections);
NavigationPageService_GetShopSectionsLazy.method =
  "aysa_api.services.navigation_page.v1.NavigationPageService/GetShopSections" as const;

// GetShopSectionsNext returns the next [limit] shop sections based on [ContinuationToken]
export const NavigationPageService_GetShopSectionsNextLazy = () =>
  import("./service.grpc").then(
    (m) => m.NavigationPageService_GetShopSectionsNext
  );
NavigationPageService_GetShopSectionsNextLazy.method =
  "aysa_api.services.navigation_page.v1.NavigationPageService/GetShopSectionsNext" as const;

// GetBrandSectionElement returns the body of the brand element
// Usually requested when the user is about to see the details
// Note: This works for all sections where brand is the elementType
export const NavigationPageService_GetBrandElementLazy = () =>
  import("./service.grpc").then((m) => m.NavigationPageService_GetBrandElement);
NavigationPageService_GetBrandElementLazy.method =
  "aysa_api.services.navigation_page.v1.NavigationPageService/GetBrandElement" as const;

// GetCategoryElement returns the body of the category element
export const NavigationPageService_GetCategoryElementLazy = () =>
  import("./service.grpc").then(
    (m) => m.NavigationPageService_GetCategoryElement
  );
NavigationPageService_GetCategoryElementLazy.method =
  "aysa_api.services.navigation_page.v1.NavigationPageService/GetCategoryElement" as const;

// GetCategoryHighlightElement returns the body of the category highlight element
export const NavigationPageService_GetCategoryHighlightElementLazy = () =>
  import("./service.grpc").then(
    (m) => m.NavigationPageService_GetCategoryHighlightElement
  );
NavigationPageService_GetCategoryHighlightElementLazy.method =
  "aysa_api.services.navigation_page.v1.NavigationPageService/GetCategoryHighlightElement" as const;

// GetProductStream returns a stream of products
export const NavigationPageService_GetProductStreamLazy = () =>
  import("./service.grpc").then(
    (m) => m.NavigationPageService_GetProductStream
  );
NavigationPageService_GetProductStreamLazy.method =
  "aysa_api.services.navigation_page.v1.NavigationPageService/GetProductStream" as const;

// GetProductStreamNext returns the next page of products
export const NavigationPageService_GetProductStreamNextLazy = () =>
  import("./service.grpc").then(
    (m) => m.NavigationPageService_GetProductStreamNext
  );
NavigationPageService_GetProductStreamNextLazy.method =
  "aysa_api.services.navigation_page.v1.NavigationPageService/GetProductStreamNext" as const;
